import { render, staticRenderFns } from "./shimmer.vue?vue&type=template&id=73262b04&scoped=true&"
import script from "./shimmer.vue?vue&type=script&lang=js&"
export * from "./shimmer.vue?vue&type=script&lang=js&"
import style0 from "./shimmer.vue?vue&type=style&index=0&id=73262b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73262b04",
  null
  
)

export default component.exports